import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=15859f7c"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&id=15859f7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports